import { render } from "./AdminThicknessView.vue?vue&type=template&id=140e1886"
import script from "./AdminThicknessView.vue?vue&type=script&lang=js"
export * from "./AdminThicknessView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__